import { Order } from "../../views/Payment/OrderRefund/ViewOrderRefund";
import { apiSlice } from "../apiSlice";

export interface GetSetMenuItemsResponse {
  items: Array<any>;
}

export interface StatusUpdateRequestData {
  orderId: string;
  orderStatus: string;
  specialNote: string;
}

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;

export const orderService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    findOrderDataByOrderId: builder.mutation<Order, string>({
      query: (OrderID) => ({
        url: `https://adminhttps-getorderbyid-${API_BASE_DOMAIN}-uc.a.run.app?orderId=${OrderID}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useFindOrderDataByOrderIdMutation
} = orderService;
